import SessionStatusUpdater from "@kaspernj/api-maker/build/session-status-updater.js"

export default async function UsersSignOut() {
  const args = {scope: "user"}

  await User.signOut()
  Devise.setSignedOut(args)
  // Fire-and-forget: the session-status refresh can land after the session is
  // already torn down. Log and swallow its rejection so a mid-teardown error
  // cannot surface as an unhandled rejection and fail specs via the test
  // ErrorLogger, while still leaving a trace in the console.
  void SessionStatusUpdater.current().updateSessionStatus().catch((error) => console.error(error))
  Devise.callSignOutEvent(args)
  await CanCan.current().resetAbilities()
}
